import { Link } from 'react-router-dom';
import { siteConfig, footerLinks, sportsCategories } from '@/mocks/common';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-10">
            <div className="lg:col-span-2">
              <Link to="/" className="inline-block mb-4">
                <span className="font-heading text-2xl font-bold text-background-50">
                  {siteConfig.name}
                </span>
              </Link>
              <p className="text-foreground-300 text-sm leading-relaxed max-w-sm mb-5">
                {siteConfig.description}
              </p>
              <div className="flex items-center gap-4">
                <a href={`mailto:${siteConfig.contact.email}`} className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-100 hover:bg-primary-600 transition-colors cursor-pointer" aria-label="邮箱">
                  <i className="ri-mail-line"></i>
                </a>
                <span className="text-foreground-400 text-sm">{siteConfig.contact.email}</span>
              </div>
            </div>

            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h4 className="text-background-50 font-semibold text-sm mb-4 whitespace-nowrap">{title}</h4>
                <ul className="space-y-2.5">
                  {links.map((link) => (
                    <li key={link.href}>
                      <Link
                        to={link.href}
                        className="text-foreground-400 hover:text-background-50 text-sm transition-colors whitespace-nowrap cursor-pointer"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            <div>
              <h4 className="text-background-50 font-semibold text-sm mb-4 whitespace-nowrap">热门赛事</h4>
              <ul className="space-y-2.5">
                {sportsCategories.slice(0, 4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-foreground-400 hover:text-background-50 text-sm transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-500 text-xs">
              &copy; {new Date().getFullYear()} {siteConfig.name} 版权所有
            </p>
            <div className="flex items-center gap-6">
              <span className="text-foreground-500 text-xs">18+ 理性娱乐</span>
              <span className="text-foreground-500 text-xs">持照经营</span>
              <span className="text-foreground-500 text-xs">公平公正</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}